import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Gamepad2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL || window.location.origin}/api`;

const Onboarding = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    siteName: 'PlayCity Abidjan',
    siteAddress: '',
    sitePhone: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/onboarding`, formData, { withCredentials: true });
      toast.success('Configuration terminée !');
      await checkAuth(); // Refresh user data
      navigate('/app/dashboard');
    } catch (error) {
      console.error('Erreur onboarding:', error);
      toast.error('Erreur lors de la configuration');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B132B] p-4">
      <div className="w-full max-w-2xl">
        <div className="glass-effect rounded-2xl p-8 shadow-2xl">
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-[#C6A15B] to-[#B89149] rounded-2xl flex items-center justify-center shadow-xl">
              <Gamepad2 className="w-12 h-12 text-[#0B132B]" strokeWidth={2.5} />
            </div>
            <h1 className="text-3xl font-bold text-[#EAEAEA] mb-2">Bienvenue !</h1>
            <p className="text-[#C6A15B]">Configurons votre premier site</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="siteName" className="text-[#EAEAEA] mb-2 block">Nom du site *</Label>
              <Input
                id="siteName"
                data-testid="site-name-input"
                value={formData.siteName}
                onChange={(e) => setFormData({ ...formData, siteName: e.target.value })}
                required
                className="bg-[#1C2541] border-[#C6A15B]/30 text-[#EAEAEA] focus:border-[#C6A15B]"
                placeholder="Ex: PlayCity Abidjan"
              />
            </div>

            <div>
              <Label htmlFor="siteAddress" className="text-[#EAEAEA] mb-2 block">Adresse</Label>
              <Input
                id="siteAddress"
                data-testid="site-address-input"
                value={formData.siteAddress}
                onChange={(e) => setFormData({ ...formData, siteAddress: e.target.value })}
                className="bg-[#1C2541] border-[#C6A15B]/30 text-[#EAEAEA] focus:border-[#C6A15B]"
                placeholder="Ex: Cocody, Abidjan"
              />
            </div>

            <div>
              <Label htmlFor="sitePhone" className="text-[#EAEAEA] mb-2 block">Téléphone</Label>
              <Input
                id="sitePhone"
                data-testid="site-phone-input"
                value={formData.sitePhone}
                onChange={(e) => setFormData({ ...formData, sitePhone: e.target.value })}
                className="bg-[#1C2541] border-[#C6A15B]/30 text-[#EAEAEA] focus:border-[#C6A15B]"
                placeholder="Ex: +225 XX XX XX XX XX"
              />
            </div>

            <Button
              data-testid="onboarding-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-[#C6A15B] hover:bg-[#B89149] text-[#0B132B] font-semibold py-6 text-lg rounded-xl transition-all duration-300 hover:scale-105"
            >
              {loading ? 'Configuration...' : 'Commencer'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
